import { TObject } from "../../common/TObject";
import { iData, iDataResult } from "./Data";

export type APIContact  = {
  id: number
  contactcode: string
  name: string
  address: string
  locationid: number
  room: string
  floor: string
  CustomFields: APICustomFields
  updated: string
  created: string
  version: number
  location: APILocation
}


export type APICustomFields =  {
  [key: string]: string;
}


export type  APILocation =  {
  lat: number
  lng: number
}




export class Contacts extends TObject implements iData {
  apicall: string = "/contacts/export";
  cache: APIContact[]|false  = false;
  

  dlookup(code: string, param: string) {
    return new Promise((resolve) => {
      this.debug("updateInput", code, param);

      return this.get().then((r) => {
        var found = false;
        r.forEach((element) => {
          if (element.contactcode == code) {
            var p = param.split(".");
            if (p.length > 1) {
              found = element[p[0]][p[1]];
            } else {
              found = element[p[0]];
            }
          }
        });
        if (!found) {
          console.error("Failed to find, " + code);
        }

        return resolve(found);
      });
    });
  }

  get() {
    return new Promise<APIContact[]>((resolve) => {
      if (this.cache) {
        return resolve(this.cache);
      }
      return this.CRMMap().APICall(this.apicall).then((data : { data :APIContact[]} ) => {
        this.cache = data.data;
        this.trigger("refreshed", this.cache);
        return resolve(this.cache);
      });
    });
  }

  invaledate() {
    this.cache = false;
    this.trigger("invaledate");
  }

  //no cache'd
  getLocation(locationid: string) {
    return this.CRMMap().APICall("/contacts/location/" + locationid + "?as=json");
  }

  async getByCode(code: string): Promise<any> {
    if (this.cache) {
      let tf = this.cache.find((e) => e.contactcode == code);
      if (tf) return tf;
    }

    return this.CRMMap().APICall("/contacts/" + code).then((c) => {
      if (c) {
        return c;
      }

      return this.get().then((d) => {
        return d.find((e) => e.contactcode == code);
      });
    });
  }
}
